module.exports = __webpack_public_path__ + "static/media/header-img.e5bae9cd.jpg";